const FabricationType = `
  id
  description
`;

export default FabricationType;
